const formatNumber = (value, lng) => {
  if (lng) {
    return new Intl.NumberFormat(lng).format(value);
  } else return value;
};

const format = (value, format, lng) => {
  if (format === "number") {
    return formatNumber(value.toString(), lng);
  }
};

export default format;
